import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5e6601c7"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=5e6601c7&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6601c7')) {
      api.createRecord('5e6601c7', component.options)
    } else {
      api.reload('5e6601c7', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=5e6601c7", function () {
      api.rerender('5e6601c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/message/tabs/list.vue"
export default component.exports